import RepositoryFactory from "../../admin/apis/index";
const product = RepositoryFactory.EcomProduct;

export default {
  addProduct({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await product.addProduct(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editProduct({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await product.editProduct(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  insertMeta({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await product.insertMeta(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getProduct({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await product.getProduct();

        commit("SET_PRODUCT", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllProduct({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        let curPage = state.currentPageState - 1;
        let payload = {
          limit: state.perPageState,
          offset: curPage,
        };

        if (state.searchState !== "") {
          Object.assign(payload, { search: state.searchState.trim() });
        }
        const { data } = await product.getAllProduct(payload);

        commit("SET_ALLPRODUCT", data.data);
        // commit("SET_TOTALROWSSTATE", data.data.totalCount);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  productImage({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await product.productImage(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editProductImage({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await product.editProductImage(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteProductImage({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await product.deleteProductImage(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteProduct({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await product.deleteProduct(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
